module.exports = __webpack_public_path__ + "img/page15.f63be49f.jpg";